export const emptySections = () => ({
  contact: { fullName: '', jobTitle: '', email: '', phone: '', location: '', website: '' },
  summary: '',
  experience: [],
  education: [],
  skills: [],
  projects: [],
  certifications: [],
  languages: [],
  custom: [],
});

export const emptyIndiaFields = () => ({ enabled: false, photo: '', dob: '', declaration: '' });

const uid = () => (typeof crypto !== 'undefined' && crypto.randomUUID ? crypto.randomUUID() : `id_${Math.random().toString(36).slice(2)}`);

export const newExperience = () => ({ id: uid(), company: '', role: '', startDate: '', endDate: '', description: '', bullets: [] });
export const newEducation = () => ({ id: uid(), institution: '', degree: '', startDate: '', endDate: '', grade: '' });
export const newProject = () => ({ id: uid(), name: '', link: '', description: '' });
export const newCertification = () => ({ id: uid(), name: '', issuer: '', date: '' });
export const newLanguageItem = () => ({ id: uid(), language: '', proficiency: '' });
export const newCustom = () => ({ id: uid(), title: '', content: '' });

export const formatDate = (iso) => {
  if (!iso) return '';
  try {
    const d = new Date(iso);
    return d.toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' });
  } catch (e) {
    return iso;
  }
};
